import Head from 'next/head'
import { useStaticData } from '@mc/static-data-react'

const Meta = () => {
  const { course, metadata } = useStaticData()

  return (
    <Head>
      <title>{course.title}</title>

      {metadata?.meta &&
        Object.entries(metadata.meta).map(
          ([key, value]) =>
            value && <meta key={key} name={key} content={value} />,
        )}

      {metadata?.structuredData &&
        metadata.structuredData.length > 0 &&
        metadata.structuredData.map((entity) => (
          <script
            key={entity['@type']}
            type='application/ld+json'
            dangerouslySetInnerHTML={{ __html: JSON.stringify(entity) }}
          />
        ))}
    </Head>
  )
}

export default Meta
